module.exports = __webpack_public_path__ + "static/media/rc-filled.1879bbb8.svg";